import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { isBigBullet } from '../helpers';
export var getDefaultStyleSheet = _ref => {
  var {
    designContext,
    customBulletContent,
    description,
    isLast,
    lineState,
    lineStyle,
    noStartPadding,
    state,
    title
  } = _ref;
  var VERTICAL_LINE_PADDING = 2;
  var bulletSize = designContext.get('stepper/bullet-size', {
    bulletSize: isBigBullet({
      customBulletContent,
      state
    }) ? 'big' : 'default'
  }).value();
  var bigBulletSize = designContext.get('stepper/bullet-size', {
    bulletSize: 'big'
  }).value();
  var bulletPadding = (bigBulletSize - bulletSize) / 2;
  var lineWidth = designContext.get('stepper/line-width').value();
  return {
    wrapperStyle: {
      display: 'flex',
      flexDirection: 'row'
    },
    bulletAndLineWrapperStyle: {
      marginLeft: noStartPadding ? 0 : bulletPadding
    },
    bulletStyle: {
      marginRight: bulletPadding,
      marginTop: bulletPadding,
      marginBottom: bulletPadding,
      backgroundColor: designContext.get('stepper/bullet-background-color', {
        state
      }).toString(),
      borderRadius: designContext.get('stepper/bullet-corner-radius').value(),
      width: bulletSize,
      height: bulletSize,
      alignItems: 'center',
      justifyContent: 'center'
    },
    bulletContentTextStyle: _objectSpread(_objectSpread({
      color: designContext.get('stepper/bullet-content-color', {
        state
      }).toString()
    }, designContext.get('stepper/bullet-content-text-style').styles()), {}, {
      alignItems: 'center',
      justifyContent: 'center'
    }),
    loaderWrapperStyle: {
      position: 'absolute',
      marginLeft: -bulletPadding
    },
    lineContainerStyle: {
      marginTop: VERTICAL_LINE_PADDING,
      marginBottom: VERTICAL_LINE_PADDING,
      borderColor: designContext.get('stepper/line-color', {
        lineState
      }).toString(),
      borderRadius: designContext.get('stepper/line-corner-radius', {
        lineStyle
      }).value(),
      width: 0,
      flexGrow: 1,
      marginLeft: (bulletSize - lineWidth) / 2,
      borderStyle: lineStyle,
      borderWidth: lineWidth / 2
    },
    contentWrapperStyle: {
      display: 'flex',
      flexDirection: 'column',
      flexShrink: 1,
      marginLeft: designContext.get('space/100').value(),
      marginBottom: isLast ? 0 : designContext.get('space/200').value()
    },
    titleStyle: _objectSpread({
      color: designContext.get('stepper/title-text-color', {
        state
      }).toString()
    }, designContext.get('stepper/title-text-style').styles()),
    descriptionStyle: _objectSpread({
      marginTop: title !== undefined ? designContext.get('space/50').value() : 0,
      color: designContext.get('stepper/description-text-color', {
        state
      }).toString()
    }, designContext.get('stepper/description-text-style').styles()),
    customContentWrapperStyle: {
      marginTop: title !== undefined || description !== undefined ? designContext.get('space/200').value() : 0
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map